import React, { useEffect, useState } from "react";
import { Flex, Box } from '@chakra-ui/react'
import { InAppProps } from "../../types/page";
import { useLocation } from "react-router-dom";
import SideBar from "../SideBar";
import applicationsList from '../../assets/json/applications2.json'
import customerList from '../../assets/json/customer.json'
import ErrorBoundary from "../../components/error/ErrorBoundary";
import PrivateInAppRoutes from "../../components/routes/PrivateInAppRoutes";
import DashboardHeader from "../DashboardHeader";

export default function InAppDashboard({
    customer,
    application,
    getApplication,
    clearFilters,
    ...props
}: InAppProps) {    
    const location = useLocation();
    const app = applicationsList[0]
    const customerTwo = customerList[0];
    const [isOverview, setIsOverview] = useState<boolean>(false)
    const userId = '646a0ebeffb5eb7319b989fe';

    const pathname = location.pathname;

    const selectedPath: string = pathname.split('/')[3];
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [currentPage, setCurrentPage] = useState("");
    
    const data = { username: 'Uzo', currentPage: currentPage  }

    function collapseSidebar() {
        setIsCollapsed(!isCollapsed)
    }

    function computeAndSetCurrentPage(pageName: string) {        
        setCurrentPage(pageName)
    }    
    
    useEffect(() => {
        if (selectedPath === 'overview') {            
            setIsOverview(true)
        } else {
            setIsOverview(false)
        }        
    }, [selectedPath])

    return (
        <Flex>
           <SideBar 
                userId={app.applicationDetail.userId}
                collapsed={isCollapsed}
				selected={selectedPath}
				applicationName='Keith & Sons'
                changeMenuState={collapseSidebar}
                onSetCurrentPage={computeAndSetCurrentPage}
           />

           {app && customerTwo && (
                <Box className="dashboard-content">
                    <ErrorBoundary userId={userId} applicationName={app.name}>
                        <DashboardHeader {...data} isOuterDashboard={false} />
                        <div className="layout">
                            <Box borderWidth='1px' borderRadius='md' overflow='hidden' className={!isOverview ? 'inner-layout' : 'inner-layout no--bg'}>
                                <PrivateInAppRoutes /> 
                            </Box>
                        </div>
                    </ErrorBoundary>
                </Box>
           )}
        </Flex>
    )
}